import { Dropdown } from 'antd'
import DotsButton from '../DotsMenu/DotsMenu'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { goalsConstants } from 'locale/goals'

type DotsMenuProps = {
  onUnlink: () => void
}

const DotsMenuSupport = (props: DotsMenuProps) => {
  const { onUnlink } = props
  const { t } = useTranslation(NAMESPACE.GOALS)

  const items = [
    {
      key: '1',
      label: (
        <ConfirmationModal>
          <div onClick={onUnlink}>{t(goalsConstants.UNLINK)}</div>
        </ConfirmationModal>
      ),
    },
  ]

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items,
      }}
    >
      <DotsButton />
    </Dropdown>
  )
}

export default DotsMenuSupport
